import { Stack, ValueOrDash } from 'ui-components';
import { CompleteServiceExecutionFragment, ServiceState } from 'drycut-graphql';
import CustomerPickupTime from '../CustomerPickupTime';
import HoldServiceButton from './HoldServiceButton';
import { CustomerBookingIcons } from '../../CustomerBookingIcons';
import { BookingWaitingTime } from 'controlled-components';
import { twMerge } from 'tailwind-merge';
import { ScissorsIcon } from '@heroicons/react/24/solid';
import QueueTable from '../QueueTable';
import { ExpectedTime } from './ExpectedTime';

type Props = {
  serviceExecution: CompleteServiceExecutionFragment;
};

export default function QueuedServiceRow({ serviceExecution }: Props): React.ReactElement {
  const serviceStarted = serviceExecution.state === ServiceState.Started;
  const defaultClasses = 'antialiased text-left font-aribau bg-zinc-100 text-xs';
  const classNames = twMerge(defaultClasses, serviceStarted ? 'bg-primary-600/30 opacity-70' : '');

  return (
    <tr className={classNames}>
      <QueueTable.TableCell className="text-[0.65rem] text-zinc-500">
        {serviceExecution.booking.bookingCode}
      </QueueTable.TableCell>

      <QueueTable.TableCell className="font-aribaubold text-zinc-700">
        {serviceExecution.booking.customName || serviceExecution.customer?.name}
      </QueueTable.TableCell>

      <QueueTable.TableCell>
        <ExpectedTime serviceExecution={serviceExecution} />
      </QueueTable.TableCell>

      <QueueTable.TableCell>
        {!serviceStarted ? (
          <BookingWaitingTime booking={serviceExecution.booking} showZero />
        ) : (
          <ValueOrDash value={null} />
        )}
      </QueueTable.TableCell>

      <QueueTable.TableCell>
        {!serviceStarted ? (
          <CustomerPickupTime calledAt={serviceExecution.calledAt} />
        ) : (
          <ValueOrDash value={null} />
        )}
      </QueueTable.TableCell>

      <QueueTable.TableCell>
        <Stack direction="row" gap={1}>
          {serviceStarted && <ScissorsIcon className="w-4 h-4 fill-primary-800" />}
          <ValueOrDash value={serviceExecution.stylist?.name} />
        </Stack>
      </QueueTable.TableCell>

      <QueueTable.TableCell>
        <ValueOrDash value={serviceExecution.booking.coupon?.code} />
      </QueueTable.TableCell>

      <QueueTable.TableCell>
        <Stack direction="row" className="items-center justify-end" gap={2}>
          {serviceExecution.customer && (
            <CustomerBookingIcons
              size="small"
              booking={serviceExecution.booking}
              customer={serviceExecution.customer}
              showPreferencesIcon={false}
            />
          )}
          <HoldServiceButton serviceExecution={serviceExecution} disabled={serviceStarted} />
        </Stack>
      </QueueTable.TableCell>
    </tr>
  );
}
